<template>
	<font-awesome-icon :icon="['fas', 'check']" class="icon ml-2 text-success" />
</template>

<script>
export default {
	name: 'CheckIcon'
}
</script>
